export default function validateMobilePhoneNumber(mobilePhoneNumber: string): boolean {
  return mobilePhoneNumber.length > 0 && !/^([0-9]{1,15})$/.test(mobilePhoneNumber);

  // ori code
  // if (mobilePhoneNumber.length > 0 && !/^([0-9]{1,15})$/.test(mobilePhoneNumber)) {
  //   return (<Trans>The phone number must be numeric and cannot contain whitespaces.</Trans>);
  // }
}
